const routes = [
  {
    path: "/manutencao-habilitacao-componente",
    name: "manutencao-habilitacao-componente",
    meta: {
      allowedPermissions: ["habilitacao_curso_por_disciplina_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoHabilitacaoDisciplina/ManutencaoHabilitacaoDisciplinaHome.vue"
      ),
  },
  {
    path: "/manutencao-habilitacao-componente/novo",
    name: "manutencao-habilitacao-componente-novo",
    meta: {
      allowedPermissions: ["habilitacao_curso_por_disciplina_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoHabilitacaoDisciplina/ManutencaoHabilitacaoDisciplinaCad.vue"
      ),
  },
  {
    path: "/manutencao-habilitacao-componente/editar/:id",
    name: "manutencao-habilitacao-componente-editar",
    meta: {
      allowedPermissions: ["habilitacao_curso_por_disciplina_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoHabilitacaoDisciplina/ManutencaoHabilitacaoDisciplinaEdit.vue"
      ),
  },
];

export default routes;
